module.exports = __webpack_public_path__ + "r-v3/img/emoti-show-off.7e70abc8.svg";